// collection grid js
var WB_LISTGRID_KEY = 'wbListGridView';
var WB_LISTGRID_MODES = ['listv', 'twogrid', 'threegrid', 'fourgrid'];

function applyListGridView(mode) {
  var productGrid = document.getElementById('product-grid');
  if (!productGrid || !mode) return;

  Array.from(document.querySelectorAll('.wblistgridbtn')).forEach(function (e) {
    e.classList.remove('active');
  });
  Array.from(document.querySelectorAll('.wblistgridbtn.' + mode)).forEach(function (e) {
    e.classList.add('active');
  });

  productGrid.classList.remove('product-list', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop', 'grid--2-col-desktop');

  if (mode === 'listv') {
    productGrid.classList.add('product-list');
    if (window.innerWidth < 992) {
      var twoGrid = document.querySelector('.twogrid');
      if (twoGrid) twoGrid.classList.remove('active_mobile');
    }
  } else if (mode === 'twogrid') {
    productGrid.classList.add('grid--2-col-desktop');
  } else if (mode === 'fourgrid') {
    productGrid.classList.add('grid--4-col-desktop');
  } else if (mode === 'threegrid') {
    productGrid.classList.add('grid--3-col-desktop');
  }
}

function listgridJavascript() {
  applyListGridView(sessionStorage.getItem(WB_LISTGRID_KEY));

  Array.from(document.querySelectorAll('.wblistgridbtn')).forEach(function (link) {
    if (link.dataset.listgridBound) return;
    link.dataset.listgridBound = '1';

    function handleEvent(event) {
      if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
        var mode = WB_LISTGRID_MODES.find(function (m) {
          return link.classList.contains(m);
        });
        if (!mode) return;
        sessionStorage.setItem(WB_LISTGRID_KEY, mode);
        applyListGridView(mode);
      }
    }
    link.addEventListener('click', handleEvent);
    link.addEventListener('keydown', handleEvent);
  });
}

function bindListGridObserver() {
  var container = document.getElementById('ProductGridContainer');
  if (!container || container.dataset.listgridObserved) return;
  container.dataset.listgridObserved = '1';
  new MutationObserver(function () {
    applyListGridView(sessionStorage.getItem(WB_LISTGRID_KEY));
  }).observe(container, { childList: true });
}

document.addEventListener('shopify:section:load', function () {
  listgridJavascript();
  bindListGridObserver();
});
listgridJavascript();
bindListGridObserver();



function animateDigit(wrapper, newDigit) {
  const current = wrapper.querySelector('.digit');
  if (current && current.textContent == newDigit) return;

  const newEl = document.createElement('span');
  newEl.className = 'digit';
  newEl.textContent = newDigit;
  newEl.style.transform = 'translateY(100%)';
  newEl.style.transition = 'none';
  wrapper.appendChild(newEl);
  newEl.getBoundingClientRect();

  requestAnimationFrame(() => {
    newEl.style.transition = current ? 'transform 0.3s ease-in-out' : 'none';
    newEl.style.transform = 'translateY(0%)';
    if (current) {
      current.style.transition = 'transform 0.3s ease-in-out';
      current.style.transform = 'translateY(-100%)';
    }
  });

  setTimeout(() => {
    const digits = wrapper.querySelectorAll('.digit');
    digits.forEach((d, i) => { if (i < digits.length - 1) d.remove(); });
  }, 300);
}

function updateAnimatedDigits(el, value) {
  const padded = value.toString().padStart(2, '0');

  if (!el.classList.contains('digitized')) {
    el.innerHTML = '';
    for (const digit of padded) {
      const wrapper = document.createElement('span');
      wrapper.className = 'digit-wrapper';
      const digitEl = document.createElement('span');
      digitEl.className = 'digit';
      digitEl.textContent = digit;
      wrapper.appendChild(digitEl);
      el.appendChild(wrapper);
    }
    el.classList.add('digitized');
    return;
  }

  el.querySelectorAll('.digit-wrapper').forEach((w, i) => {
    animateDigit(w, padded[i]);
  });
}

function countDown() {
  document.querySelectorAll('.countd_all').forEach(section => {
    const endDate = new Date(section.dataset.date.replaceAll('-', '/')).getTime();
    const now = Date.now();
    const distance = endDate - now;

    const [d, h, m, s] = distance > 0 ? [
      Math.floor(distance / 86400000),
      Math.floor((distance % 86400000) / 3600000),
      Math.floor((distance % 3600000) / 60000),
      Math.floor((distance % 60000) / 1000)
    ] : [0, 0, 0, 0];

    updateAnimatedDigits(section.querySelector('.wb_cdays'), d);
    updateAnimatedDigits(section.querySelector('.wb_chours'), h);
    updateAnimatedDigits(section.querySelector('.wb_cminutes'), m);
    updateAnimatedDigits(section.querySelector('.wb_cseconds'), s);
  });
}
setInterval(countDown, 1000);
countDown();

document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('[id^="MediaGallery"]');
  if (!gallery) return;
  const youtubePlayers = new Map();
  let youtubeAPILoaded = false;
  function loadYouTubeAPI() {
    if (youtubeAPILoaded) return;
    youtubeAPILoaded = true;
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  function pauseAllVideos(exceptVideo = null) {
    // Pause all HTML5 videos except the one passed
    const allVideos = gallery.querySelectorAll('video');
    if (allVideos.length) {
      allVideos.forEach((video) => {
        if (video !== exceptVideo && !video.paused) {
          video.pause();
        }
      });
    }
    // Pause all YouTube videos except the one passed
    youtubePlayers.forEach((player, iframe) => {
      if (iframe !== exceptVideo) {
        player.pauseVideo();
      }
    });
    // reset 3d model
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  gallery.addEventListener('click', function (event) {
    const clickedMedia = event.target.closest('[data-media-id]');
    if (!clickedMedia) return;
    const clickedVideo = clickedMedia.querySelector('video');
    if (clickedVideo) {
      pauseAllVideos(clickedVideo);
    }
    const clickedIframe = clickedMedia.querySelector('iframe');
    if (clickedIframe && clickedIframe.src.includes('youtube.com')) {
      pauseAllVideos(clickedIframe);
    }
  });
  const observer = new MutationObserver(() => {
    // Add play event listeners to all HTML5 videos
    const allVideos = gallery.querySelectorAll('video');
    if (allVideos.length > 0) {
      allVideos.forEach((video) => {
        video.addEventListener('play', () => {
          pauseAllVideos(video);
        });
      });
    }
    // Find all YouTube iframes
    const iframes = gallery.querySelectorAll('iframe[src*="youtube.com"]');
    if (iframes.length > 0) {
      loadYouTubeAPI();
      // If YouTube API is already loaded, create players for new iframes
      if (window.YT && window.YT.Player) {
        iframes.forEach((iframe) => {
          if (!youtubePlayers.has(iframe)) {
            const player = new YT.Player(iframe, {
              events: {
                onStateChange: function (event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    pauseAllVideos(iframe);
                  }
                }
              }
            });
            youtubePlayers.set(iframe, player);
          }
        });
      }
    }
  });
  observer.observe(gallery, {
    childList: true,
    subtree: true,
  });
  // This is called once YouTube iframe API is ready
  window.onYouTubeIframeAPIReady = function () {
    const iframes = gallery.querySelectorAll('iframe[src*="youtube.com"]');
    if (!iframes.length) return;
    iframes.forEach((iframe) => {
      if (!youtubePlayers.has(iframe)) {
        const player = new YT.Player(iframe, {
          events: {
            onStateChange: function (event) {
              if (event.data === YT.PlayerState.PLAYING) {
                pauseAllVideos(iframe);
              }
            }
          }
        });
        youtubePlayers.set(iframe, player);
      }
    });
  };
});